/*
File: 渲染内购商品详情
Author: SimonLu<luzuoqing@huya.com>
Date: 2020-03-16
*/
import React, { useState, useEffect } from 'react'
import * as R from 'ramda'
import classnames from 'classnames';
import { Modal, Button, Table, message, Icon } from 'antd'
import styles from '../style.scss?__local';
import { getGoodsList } from '@/api/api'
import { useAction } from '@/hooks/useAction'
import HyModal from '@cmps/HyModal/HyModal'
import SimpleTable from '@cmps/SimpleTable/SimpleTable'

const columns = {
  3: [ // 时长买断类
    {
      title: '有效时长(天)',
      dataIndex: 'rangeText',
    },
    {
      title: '金额(虎牙币)',
      dataIndex: 'fee',
    },
  ],
  4: [ // 礼物分成
    {
      title: '礼物收益梯度(金豆)',
      dataIndex: 'rangeText',
    },
    {
      title: '对应费率(%)',
      dataIndex: 'fee',
      render: (value, row) => {
        if (row.rangeText === '封顶费用') {
          return <div dangerouslySetInnerHTML={{ __html: value }} />
        } else {
          return <span>{value}</span>
        }
      },
    },
  ],
}

const parseMin = value => (parseInt(value, 10) <= 0 ? 0 : value)
const parseMax = value => (parseInt(value, 10) === -1 ? '永久' : value)

const dataAdapter = goods => {
  const type = R.path(['goodsFeeRule', 'type'])(goods)
  const conditions = R.path(['goodsFeeRule', 'conditions'])(goods)

  if (type === 3) {
    return conditions.map(item => ({
      // rangeText: item.range.max === -1 ? '永久' : `${item.range.max}天`,
      rangeText: parseMax(item.range.max),
      fee: item.fee,
    }))
  }

  if (type === 4) {
    const maxFee = R.path(['goodsFeeRule', 'maxFee'])(goods)

    const transformer = item => {
      const { range, fee } = item
      if (!range.min || range.min === 0) {
        return {
          rangeText: `< ${range.max}`,
          fee,
        }
      }
      if (!range.max || range.max === -1) {
        return {
          rangeText: `${range.min} + `,
          fee,
        }
      }
      if (range.min && range.max) {
        return {
          rangeText: `${range.min} - ${range.max}`,
          fee,
        }
      }
    }

    const sorted = R.sortBy(R.path(['range', 'min']))(conditions)

    const min = R.compose(
      R.path(['range', 'min']),
      R.head,
    )(sorted)

    const mapped = R.compose(
      R.prepend({
        rangeText: `< ${min}`,
        fee: '免费',
      }),
      R.map(transformer),
    )(sorted)



    if (goods.goodsFeeRule.maxFee) {
      return [
        ...mapped,
        {
          rangeText: '封顶费用',
          fee: `<span style="color: #FF9600">${goods.goodsFeeRule.maxFee}</span> 虎牙币`,
        },
      ]
    } else {
      return mapped
    }

  }

}

export default function InAppPurchase({ extUuid }) {
  const [{ isLoading, respData, error }, performGetGoods] = useAction(getGoodsList)
  // const [{ isLoading, error }, performGetGoods] = useAction(getGoodsList)
  // const [respData, setData] = useState([])
  const [isListVisible, toggleList] = useState(false)
  const [isDetailVisible, toggleDetail] = useState(false)
  const [detail, setDetail] = useState({
    columns: [],
    data: [],
  })

  useEffect(() => {
    // setData(mockData)
    performGetGoods(extUuid)
  }, [])

  const handleClick = goods => {
    setDetail({
      columns: columns[goods.goodsFeeRule.type],
      data: dataAdapter(goods),
    })
    toggleDetail(true)
  }

  if (!respData || respData.length <= 0) return null

  return (
    <div className={styles['in-app-purchase']}>
      <div className={styles['app-sec']}>
        <div className={classnames(styles['app-sec-tit'], styles['app-sec-tit--iap'])}>
          <div className={styles['app-sec-tit--iap__btn']}>
            <span>内购商品详情</span>
            <button onClick={() => toggleList(R.not)}>
              {isListVisible ? '收起' : '展开'}
              <Icon type={isListVisible ? 'up' : 'down'} />
            </button>
          </div>
          <p className={styles['app-sec-tit--iap__desc']}> 小程序中并非全部功能都是免费向您开放的，您使用以下特色功能时需要额外收取费用，如果您在使用时同意了付费协议，则视为您认同应当支付产生的费用。
          </p>
        </div>
        <div>
          <ul className={classnames(styles['goods-list'], { [styles['goods-list--hidden']]: !isListVisible })}>
            {
              respData.map(item => (
                <li key={item.goodsUuid} className={styles.goods}>
                  <span className={styles.name}>{item.goodsName}:</span>
                  <span className={styles.desc}>{item.goodsDesc}</span>
                  <p className={styles['show-detail']} onClick={() => handleClick(item)}>
                    <span>付费详情</span>
                    <Icon type="right" />
                  </p>
                </li>
              ))
            }
          </ul>
        </div>
        <HyModal
          className={styles['detail-dialog']}
          title="付费详情"
          width={420}
          visible={isDetailVisible}
          onCancel={() => toggleDetail(false)}
          onOk={() => toggleDetail(false)}
          footer={null}
        >

          <SimpleTable
            className={styles['detail-table']}
            columns={detail.columns}
            dataSource={detail.data}
            bordered
            pagination={false}
          />
        </HyModal>
      </div>
      <div className={styles['app-sec-line']}>
      </div>
    </div>)
}
